import { QueryConfig } from 'metrics-chart'

export enum ReportType {
  Benchmark,
  Workload,
  // Infra,
  Comparison,
  Health,
  OOM,
  SlowLogVisual,
  TrafficMirror
}

export interface PromQLSchema {
  name: string
  expr: string
  unit: string
  component: string
  dashboard: PromQLDashboard[]
}

export interface PromQLDashboard {
  title: string
  id: {
    op: string
    cloud: string
  }
}

export enum AdviceLevel {
  Error = 'error',
  Warning = 'warning',
  Info = 'info'
}

export interface Advice {
  id: number
  name: string
  qualified: boolean
  level: AdviceLevel
  // the identifier of the category which related to advices(o2m for now)
  category: string[]
  // the promql id where the advice comes from
  // https://github.com/pingcap-inc/compute-engine/blob/master/jobs/metrics-snapshot/promql.yaml
  metrics: string[]
  component: string
  type: string
  // key and variables for i18n content
  content: {
    key: string
    variables: any
    link?: string
  }
}

export interface MetricStats {
  // not necessary on the fe for now
  category: string[]
  errMsg: string
  // metric stats identifier
  name: string
  unit: string
  values: { [k: string]: MetricValue }
}

export interface MetricValue {
  value: any
  unit?: string
}

export interface ReportBasic<T = any> {
  args: ReportArgs
  creator: string
  createdAt: number
  data: T
  progress: number
  status: string
}

export interface ReportArgs {
  begin_ts: number
  end_ts: number
  org_type: 'cloud' | 'op'
}

export type MetricsChartQueryConfig = Omit<QueryConfig, 'promql'> & {
  promqlId: string
}
